export default __webpack_public_path__ + "static/media/profile7.f8cf682c.png";